export default {
    BASE_URL: '/pms/audit',
    api: [
        {
            name: 'auditList',
            desc: '获取数据列表',
            method: 'GET',
            path: '/list' 
        },
        {
            name: 'teamMember',
            desc: '班组退场获取班组成员',
            method: 'GET',
            path: '/team/member' 
        },
        {
            name: 'teamExit',
            desc: '班组退场审核',
            method: 'PUT',
            path: '/team/exit'
        }
    ]
}


// WEBPACK FOOTER //
// ./src/api/project/audit.js